<template>
  <section class="interview_section" v-if="homepageBanners.length">
    <div class="container">
      <ul>
        <!-- first -->
        <VueSlick v-bind="slickSettings">
          <li v-for="homepageBanner in homepageBanners" :key="homepageBanner.id">
            <div class="card interview_card">
              <img class="card-img-top" :src="homepageBanner.imageUrl" alt="gaming_img.svg">
              <div class="card-img-overlay text-center">
                <div class="card_content ">
                  <h4 class="card-title">{{homepageBanner.title}}</h4>
                  <h5>{{homepageBanner.created_at}}</h5>
                  <p class="card-text">{{homepageBanner.description}}</p>
                </div>
              </div>
            </div>
          </li>
        </VueSlick>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomepageBanners',
  data () {
    return {
      homepageBanners: [],
      slickSettings: {
        dots: false,
        infinite: true,
        arrows: true,
        swipeToSlide: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: true,
        autoplay: false,
        autoplaySpeed: 2000,
        fade: true,
        cssEase: 'linear'
      }
    }
  },
  mounted () {
    this.fetchHomepageBanners()
  },
  methods: {
    fetchHomepageBanners () {
      this.$store
        .dispatch('fetchHomepageBanners')
        .then((resp) => {
          this.homepageBanners = resp.data.homepageBanners
        })
        .catch((err) => this.$helper.catchHandler(err))
    }
  }
}

</script>

<style scoped>
.interview_section .interview_card h4.card-title {
  /* width: 60%; */
  margin: 0px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/HomepageBanners.vue